import _ from 'lodash';

(() => {
  angular.module('finance').controller('finance.views.debugTools', DebugToolsPageController);

  DebugToolsPageController.$inject = [
    '$scope',
    '$uibModal',
    'financeConstants',
    'abp.services.finance.debugTools',
  ];

  function DebugToolsPageController($scope, $modal, financeConsts, debugToolsSvc) {
    const vm = this;

    vm.saving = 0;

    vm.gridOptions = {
      appScopeProvider: vm,
      paginationPageSizes: financeConsts.grid.defaultPageSizes,
      paginationPageSize: financeConsts.grid.defaultPageSize,
      paginationCurrentPage: 1,
      columnDefs: getGridOptionsColumnDefs(),
      onRegisterApi(gridApi) {
        $scope.gridApi = gridApi;
      },
      data: [],
    };

    vm.actions = [
      {
        name: 'Create mock bank account deposit',
        method: openCreateMockBankAccountDepositModal,
        type: 'Mock data creator',
      },
      {
        name: 'Export billing accounts to NetSuite',
        method: openExportBillingAccountsToNetSuiteModal,
        type: 'Billing account data exporter to NetSuite',
      },
      {
        name: 'Sync Curlec transactions settlement',
        method: syncCurlecTransactionsSettlementModal,
        type: 'Curlec settlement sync tool',
      },
      {
        name: 'Update NetSuite billing account Ids to null',
        method: openUpdateNetSuiteBillingAccountIdsToNull,
        type: 'NetSuite testing cleanup tool for billing account',
      },
      {
        name: 'Update NetSuite transaction Ids to null',
        method: openUpdateNetSuiteTransactionIdsToNullModal,
        type: 'NetSuite testing cleanup tool for transaction',
      },
      {
        name: 'Update NetSuite payment Ids to null',
        method: openUpdateNetSuitePaymentIdsToNullModal,
        type: 'NetSuite testing cleanup tool for payment',
      },
      {
        name: 'Sync Curlec transactions payment status',
        method: syncCurlecTransactionsPaymentStatus,
        type: 'Curlec payment status sync tool',
      },
      {
        name: 'Export transactions to NetSuite',
        method: openExportTransactionsToNetSuite,
        type: 'NetSuite data exporter to NetSuite for transactions',
      },
      {
        name: 'Export payments to NetSuite',
        method: openExportPaymentsToNetSuite,
        type: 'NetSuite data exporter to NetSuite for payments',
      },
      {
        name: 'Sync Citibank statement',
        method: syncCitibankStatement,
        type: 'Citibank statement sync tool',
      },
      {
        name: 'Update billing accounts at NetSuite',
        method: openUpdateNetSuiteBillingAccounts,
        type: 'Billing account data updater to NetSuite',
      },
      {
        name: 'Backfill payment accounting postings',
        method: backfillPaymentAccountingPostings,
        type: 'Payment accounting postings backfill tool',
      },
    ];

    init();

    function init() {
      vm.actions = _.orderBy(vm.actions, ['type', 'name'], ['asc', 'asc']);
      vm.gridOptions.data = vm.actions;
    }

    function getGridOptionsColumnDefs() {
      const columnDefs = [
        {
          name: App.localize('Actions'),
          enableSorting: false,
          width: 90,
          headerCellTemplate: '<span></span>',
          cellTemplate: 'actionTemplate',
        },
        {
          displayName: App.localize('Name'),
          field: 'name',
          minWidth: 100,
          enableSorting: false,
        },
        {
          displayName: App.localize('Type'),
          field: 'type',
          minWidth: 100,
          enableSorting: false,
        },
      ];

      return columnDefs;
    }

    function openCreateMockBankAccountDepositModal() {
      $modal
        .open({
          templateUrl: require('./createMockBankAccountDeposit.modal.html'),
          controller: 'finance.views.debugTools.createMockBankAccountDepositModal as vm',
          backdrop: 'static',
          resolve: {
            // EMPTY as intended.
          },
        })
        .result.then(() => {
          // EMPTY as intended.
        });
    }

    function openExportBillingAccountsToNetSuiteModal() {
      $modal
        .open({
          templateUrl: require('./exportBillingAccountsToNetSuite.modal.html'),
          controller: 'finance.views.debugTools.exportBillingAccountsToNetSuiteModal as vm',
          backdrop: 'static',
          resolve: {
            // EMPTY as intended.
          },
        })
        .result.then(() => {
          // EMPTY as intended.
        });
    }

    function syncCurlecTransactionsSettlementModal() {
      $modal
        .open({
          templateUrl: require('./syncCurlecTransactionsSettlement.modal.html'),
          controller: 'finance.views.debugTools.syncCurlecTransactionsSettlementModal as vm',
          backdrop: 'static',
          resolve: {
            // EMPTY as intended.
          },
        })
        .result.then(() => {
          // EMPTY as intended.
        });
    }

    function openUpdateNetSuiteBillingAccountIdsToNull() {
      $modal
        .open({
          templateUrl: require('./updateNetSuiteBillingAccountIdsToNull.modal.html'),
          controller: 'finance.views.debugTools.updateNetSuiteBillingAccountIdsToNullModal as vm',
          backdrop: 'static',
          resolve: {
            // EMPTY as intended.
          },
        })
        .result.then(() => {
          // EMPTY as intended.
        });
    }

    function openUpdateNetSuiteTransactionIdsToNullModal() {
      $modal
        .open({
          templateUrl: require('./updateNetSuiteTransactionIdsToNull.modal.html'),
          controller: 'finance.views.debugTools.updateNetSuiteTransactionIdsToNullModal as vm',
          backdrop: 'static',
          resolve: {
            // EMPTY as intended.
          },
        })
        .result.then(() => {
          // EMPTY as intended.
        });
    }

    function openUpdateNetSuitePaymentIdsToNullModal() {
      $modal
        .open({
          templateUrl: require('./updateNetSuitePaymentIdsToNull.modal.html'),
          controller: 'finance.views.debugTools.updateNetSuitePaymentIdsToNullModal as vm',
          backdrop: 'static',
          resolve: {
            // EMPTY as intended.
          },
        })
        .result.then(() => {
          // EMPTY as intended.
        });
    }

    function syncCurlecTransactionsPaymentStatus() {
      swal(
        {
          title: App.localize('AreYouSure'),
          text: 'Confirm enqueue sync Curlec transactions payment status jobs?',
          type: 'warning',
          confirmButtonColor: '#1ab394',
          confirmButtonText: App.localize('Yes'),
          cancelButtonText: App.localize('No'),
          showCancelButton: true,
          closeOnConfirm: false,
        },
        (isConfirm) => {
          if (isConfirm) {
            debugToolsSvc.syncCurlecTransactionsPaymentStatus().success(() => {
              abp.notify.success(App.localize('Success'));
            });
          }
          swal.close();
        }
      );
    }

    function openExportTransactionsToNetSuite() {
      $modal
        .open({
          templateUrl: require('./exportTransactionsToNetSuite.modal.html'),
          controller: 'finance.views.debugTools.exportTransactionsToNetSuite as vm',
          backdrop: 'static',
          resolve: {
            // EMPTY as intended.
          },
        })
        .result.then(() => {
          // EMPTY as intended.
        });
    }

    function openExportPaymentsToNetSuite() {
      $modal
        .open({
          templateUrl: require('./exportPaymentsToNetSuite.modal.html'),
          controller: 'finance.views.debugTools.exportPaymentsToNetSuite as vm',
          backdrop: 'static',
          resolve: {
            // EMPTY as intended.
          },
        })
        .result.then(() => {
          // EMPTY as intended.
        });
    }

    function syncCitibankStatement() {
      $modal
        .open({
          templateUrl: require('./syncCitibankStatement.modal.html'),
          controller: 'finance.views.debugTools.syncCitibankStatementModal as vm',
          backdrop: 'static',
          resolve: {
            // EMPTY as intended.
          },
        })
        .result.then(() => {
          // EMPTY as intended.
        });
    }

    function openUpdateNetSuiteBillingAccounts() {
      $modal
        .open({
          templateUrl: require('./updateNetSuiteBillingAccounts.modal.html'),
          controller: 'finance.views.debugTools.updateNetSuiteBillingAccountsModal as vm',
          backdrop: 'static',
          resolve: {
            // EMPTY as intended.
          },
        })
        .result.then(() => {
          // EMPTY as intended.
        });
    }

    function backfillPaymentAccountingPostings() {
      swal(
        {
          title: App.localize('AreYouSure'),
          text: 'Confirm enqueue backfill payment accounting postings job?',
          type: 'warning',
          confirmButtonColor: '#1ab394',
          confirmButtonText: App.localize('Yes'),
          cancelButtonText: App.localize('No'),
          showCancelButton: true,
          closeOnConfirm: false,
        },
        (isConfirm) => {
          if (isConfirm) {
            debugToolsSvc.backfillPaymentAccountingPostings().success(() => {
              abp.notify.success(App.localize('Success'));
            });
          }
          swal.close();
        }
      );
    }
  }
})();
